import React, { useState } from 'react';
import DocumentViewerModal from './document-viewer-modal';

type Props = {
  children?: React.ReactNode | React.ReactNodeArray;
};
const LinkCatcher = ({ children }: Props) => {
  const [activeDocument, setActiveDocument] = useState(undefined);

  const handleLinkClick = (event: React.SyntheticEvent) => {
    const target = event.target as HTMLElement;
    if (target?.tagName === 'A') {
      const link = target as HTMLAnchorElement;
      event.preventDefault();
      setActiveDocument({ url: link.href, title: link.title || link.text });
    }
  };

  return (
    <React.Fragment>
      {activeDocument && (
        <DocumentViewerModal
          documents={activeDocument ? [activeDocument] : []}
          activeIndex={activeDocument ? 0 : undefined}
          onChange={setActiveDocument}
        />
      )}
      <div onClick={handleLinkClick}>{children}</div>
    </React.Fragment>
  );
};

export default LinkCatcher;
